import {useEffect} from "react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useBoundStore} from "../../Store/store";
import {BaseCard} from "../../Components/Cards/BaseCard";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {ShiftInfoCard} from "../../Components/Cards/ShiftInfoCard";
import PhoneCheck from "../../Assets/images/illustrations/phone_check.png";
import { statuutLabel } from "../../Utils/StatuutHelper";

export const ShiftDetail = () => {
    const {
        shiftId
    } = useParams();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const getShiftDetail = useBoundStore((state) => state.getShiftDetail);
    const shiftDetail = useBoundStore((state) => state.shiftDetail);
    const user = useBoundStore((state) => state.user);

    useEffect(() => {
        if (!shiftId) return;

        getShiftDetail(shiftId).then((detail) => {
            if (!detail) {
                console.warn('No shift detail returned for ID:', shiftId);
            }
        }).catch(error => {
            console.error('Error loading shift detail:', error);
        });
    }, [getShiftDetail, shiftId]);

    const ownApplication = shiftDetail?.applications?.find(a => a.freelancer?.id === user?.id);

    return (
        <div className="px-4 md:px-0">
            <div className={'flex flex-row justify-between mb-4 items-center'}>
                <div>
                    <h1 className={'text-2xl font-semibold'}>Shift Details</h1>
                    <div className={"flex flex-row group items-center cursor-pointer"}
                         onClick={() => navigate('/freelancer/availabilities')}>
                        <FontAwesomeIcon icon={faArrowLeft}
                                         className={'text-sm transition-all group-hover:mr-2 duration-500'}/>
                        <div className={'text-sm text-gray-500 ml-2'}>
                            {t('general.actions.back_to_overview')}
                        </div>
                    </div>
                </div>
            </div>

            <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                <div className={'md:col-span-2'}>
                    <BaseCard border={false}>
                        <h2 className="text-lg text-gray-700 uppercase mb-4">Klant informatie</h2>
                        <div className="space-y-2">
                            <ReadOnlyField
                                label={t('general.fields.company_name')}
                                value={shiftDetail?.branch?.company_name ?? '-'}
                            />
                            <ReadOnlyField
                                label={t('tables.contact')}
                                value={(shiftDetail?.branch?.contact_firstname + ' ' + shiftDetail?.branch?.contact_lastname) || '-'}
                            />
                            <ReadOnlyField
                                label={t('general.fields.tel')}
                                value={shiftDetail?.branch?.contact_tel ?? '-'}
                            />

                          <ReadOnlyField
                                label={t('general.fields.address')}
                                value={
                                    [
                                        shiftDetail?.branch?.street,
                                        shiftDetail?.branch?.number,
                                        shiftDetail?.branch?.postal,
                                        shiftDetail?.branch?.city
                                    ].filter(Boolean).join(', ') || '-'
                                }
                            />
                        </div>

                        {shiftDetail?.branch?.shift_confirmed_message && (
                            <div className="mt-6">
                                <h3 className="text-base font-bold mb-2">Extra informatie vestiging:</h3>
                                <p className="text-sm whitespace-pre-wrap bg-gray-50 p-4 rounded">{shiftDetail.branch.shift_confirmed_message}</p>
                            </div>
                        )}
                    </BaseCard>

                    {(user?.roles?.includes('admin') || user?.roles?.includes('customer')) && (
                        <BaseCard border={false} className="mt-4">
                            <h2 className="text-lg text-gray-700 uppercase mb-4">Contract</h2>
                            <div className="space-y-2">
                                <ReadOnlyField
                                    label={t('tables.status')}
                                    value={
                                        shiftDetail?.contract?.status === "completed" ? t('shifts.status_signed') :
                                            shiftDetail?.contract?.status === "cancelled" ? t('shifts.status_cancelled') :
                                                shiftDetail?.contract?.status === "sent" ? t('shifts.status_sent') :
                                                    shiftDetail?.contract?.status === "pending" ? t('shifts.status_created') :
                                                        t('shifts.no_contract')
                                    }
                                />
                                {shiftDetail?.contract?.document && (
                                    <div className="flex flex-col">
                                        <label className="text-sm text-gray-500">Document</label>
                                        <a
                                            href={shiftDetail.contract.document.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-base text-primary hover:underline"
                                        >
                                            Download contract
                                        </a>
                                    </div>
                                )}
                            </div>
                        </BaseCard>
                    )}
                </div>

                <BaseCard border={false}>
                    <ShiftInfoCard
                        shift={shiftDetail}
                        overrideImage={PhoneCheck}
                    />
                    {ownApplication?.applied_as_statuut && (user?.extra_statuten?.length ?? 0) > 0 && (
                        <div className="mt-4 pt-4 border-t border-gray-200">
                            <ReadOnlyField
                                label={t('applications.applied_as_statuut')}
                                value={statuutLabel(ownApplication.applied_as_statuut)}
                            />
                        </div>
                    )}
                </BaseCard>
            </div>
        </div>
    )
}

const ReadOnlyField = ({label, value}) => (
    <div className="flex flex-col">
        <label className="text-sm text-gray-500">{label}</label>
        <div className="text-base text-gray-800">{value !== null && value !== undefined ? value : '-'}</div>
    </div>
);
